
import { IconProps } from "@/models";

export function UnlockIcon({
  size = 24,
  color = "#000",
  opacity = "0.85",
}: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
            d="M13.0332 7.25H5.2207V3.75C5.2207 3.26719 5.61289 2.875 6.0957 2.875H9.9707C10.4535 2.875 10.8457 3.26719 10.8457 3.75V4.8125C10.8457 4.88125 10.902 4.9375 10.9707 4.9375H11.8457C11.9145 4.9375 11.9707 4.88125 11.9707 4.8125V3.75C11.9707 2.64531 11.0754 1.75 9.9707 1.75H6.0957C4.99102 1.75 4.0957 2.64531 4.0957 3.75V7.25H3.0332C2.75664 7.25 2.5332 7.47344 2.5332 7.75V13.75C2.5332 14.0266 2.75664 14.25 3.0332 14.25H13.0332C13.3098 14.25 13.5332 14.0266 13.5332 13.75V7.75C13.5332 7.47344 13.3098 7.25 13.0332 7.25ZM12.4082 13.125H3.6582V8.375H12.4082V13.125ZM7.5957 10.9531V11.7812C7.5957 11.85 7.65195 11.9062 7.7207 11.9062H8.3457C8.41445 11.9062 8.4707 11.85 8.4707 11.7812V10.9531C8.59968 10.8605 8.69595 10.7294 8.74566 10.5786C8.79536 10.4278 8.79593 10.2651 8.7473 10.114C8.69866 9.96281 8.60331 9.831 8.47499 9.73749C8.34667 9.64398 8.19198 9.5936 8.0332 9.5936C7.87442 9.5936 7.71974 9.64398 7.59142 9.73749C7.46309 9.831 7.36775 9.96281 7.31911 10.114C7.27047 10.2651 7.27105 10.4278 7.32075 10.5786C7.37045 10.7294 7.46672 10.8605 7.5957 10.9531V10.9531Z" 
            fill={color}
            fillOpacity={opacity}
        />
    </svg>

  );
}
